import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Loading, Modal } from "src/components";
import {
  Box,
  Button,
  Grid,
  FormLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Typography,
} from "@material-ui/core";

import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { atualizarPermissoes } from "src/store/actions/usuarios";

function PermissionsCheck({ open, close, usuario }) {
  const [formPermissoes, setFormPermissoes] = useState([]);
  const [loading, setLoading] = useState(false);

  const { modulos } = useSelector((state) => state.menus);

  useEffect(() => {
    if (!usuario || !usuario.permissoes) return;

    const permissoesUsuario = usuario.permissoes.split(",");
    let permissoesFinal = [];
    let bool = false;

    for (let i = 0; i < PERMISSOES.length; i++) {
      for (let j = 0; j < permissoesUsuario.length; j++) {
        if (PERMISSOES[i].id === parseInt(permissoesUsuario[j])) {
          bool = true;
          permissoesFinal.push({
            id: PERMISSOES[i].id,
            text: PERMISSOES[i].text,
            active: PERMISSOES[i].active,
            checked: true,
          });
          break;
        }
      }
      if (!bool) {
        permissoesFinal.push({
          id: PERMISSOES[i].id,
          text: PERMISSOES[i].text,
          checked: false,
          active: PERMISSOES[i].active,
        });
      }
      bool = false;
    }

    setFormPermissoes(permissoesFinal);
  }, [usuario]);

  useEffect(() => {
    if (!open) {
      setFormPermissoes(PERMISSOES);
    }
  }, [open]);

  const verificaPermissao = (permissao) =>
    /* Módulos
     * 0 = Clientes, usuarios, configurações, cashback
     * 1 = Dashboard
     * 2 = Produtos, categorias, complementos
     * 3 = Entregadores, pedidos
     * 4 = Financeiro
     */
    modulos.find((item) => (item.modulo_id === permissao ? true : false));

  const handleChange = (event) => {
    let permissoes = [];

    formPermissoes.forEach((permissao) => {
      if (permissao.id === parseInt(event.target.defaultValue)) {
        permissoes.push({ ...permissao, checked: !permissao.checked });
      } else {
        permissoes.push(permissao);
      }
    });

    setFormPermissoes(permissoes);
  };

  const handleSubmit = async () => {
    setLoading(true);

    let permissoes = [];
    for (let index in formPermissoes) {
      if (formPermissoes[index].checked) {
        permissoes.push(formPermissoes[index].id);
      }
    }

    await atualizarPermissoes(usuario.id, permissoes.join(","));
    close();
    setLoading(false);
  };

  const PERMISSOES = [
    { id: 1, text: "Dashboard", checked: false, active: verificaPermissao(1) },
    { id: 2, text: "Clientes", checked: false, active: verificaPermissao(0) },
    // { id: 3, text: "Fidelidade", checked: false },
    { id: 4, text: "Perfil", checked: false, active: true },
    { id: 5, text: "Cashback", checked: false, active: verificaPermissao(0), },
    { id: 6, text: "Produtos", checked: false, active: verificaPermissao(2) },
    { id: 7, text: "Categorias", checked: false, active: verificaPermissao(2) },
    { id: 8, text: "Complementos", checked: false, active: verificaPermissao(2), },
    { id: 9, text: "Entregadores", checked: false, active: verificaPermissao(3), },
    { id: 10, text: "Pedidos", checked: false, active: verificaPermissao(3) },
    { id: 11, text: "Usuários", checked: false, active: verificaPermissao(0) },
    { id: 12, text: "Configurações", checked: false, active: verificaPermissao(0), },
    { id: 22, text: "Comanda", checked: false, active: verificaPermissao(3) },
  ];

  return (
    <Modal open={open}>
      <Loading loading={loading} />
      <Typography>Gerenciar permissões de {usuario.nome} </Typography>
      <FormControl component="fieldset">
        <FormGroup aria-label="position" column>
          <Grid style={{ maxWidth: "500px" }} container spacing={1}>
            {formPermissoes
              .filter((row) => row.active)
              .map((row) => {
                return (
                  <Grid item sm={6}>
                    <FormControlLabel
                      value={row.id}
                      key={row.id}
                      checked={row.checked}
                      control={
                        <Checkbox color="primary" onChange={handleChange} />
                      }
                      label={row.text}
                      labelPlacement="end"
                    />
                  </Grid>
                );
              })}
          </Grid>
        </FormGroup>
      </FormControl>
      <Box
        marginTop="8px"
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Button color="primary" size="small" onClick={handleSubmit}>
          {<SaveIcon />}&nbsp;Gravar
        </Button>
        <Button color="secondary" size="small" onClick={close}>
          {<CancelIcon />}&nbsp;Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default PermissionsCheck;
